var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.prefixCls, _vm.reverseColor && 'reverse-color' ]},[_c('span',[_vm._t("term"),_vm._v(" "),_c('span',{staticClass:"item-text"},[_vm._t("default")],2)],2),_vm._v(" "),_c('span',{class:[_vm.flag]},[_c('a-icon',{attrs:{"type":("caret-" + _vm.flag)}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-9f28f096","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Trend/Trend.vue
// module id = null
// module chunks = 